import { createSlice } from "@reduxjs/toolkit"

const initialState = {
  isLoading: false,
  enrolResponse: "",
  installmentResponse: "",
  enrollments: [],
  installments: [],
  selectedEnrolment: {},
}

const enrolSlice = createSlice({
  name: "enrol",
  initialState,
  reducers: {
    isPending: (state) => {
      state.isLoading = true
    },
    enrolSuccess: (state, { payload }) => {
      state.isLoading = false
      state.enrolResponse = payload || {}
    },
    getEnrollsSuccess: (state, { payload }) => {
      state.isLoading = false
      state.enrollments = payload || {}
    },
    getSingleEnrollSuccess: (state, { payload }) => {
      state.isLoading = false
      state.selectedEnrolment = payload || {}
    },
    enrolFail: (state, { payload }) => {
      state.isLoading = false
      state.enrolResponse = payload || {}
    },
    installmentSuccess: (state, { payload }) => {
      state.isLoading = false
      state.installmentResponse = payload || {}
    },
    installmentFail: (state, { payload }) => {
      state.isLoading = false
      state.installmentResponse = payload || {}
    },
    getInstallmentSuccess: (state, { payload }) => {
      state.isLoading = false
      state.installments = payload || {}
    },
    getSingleInstallmentSuccess: (state, { payload }) => {
      state.isLoading = false
      state.selectedInstallment = payload || {}
    },
  },
})

const { reducer, actions } = enrolSlice

export const {
  enrolSuccess,
  getEnrollsSuccess,
  getInstallmentSuccess,
  getSingleInstallmentSuccess,
  getSingleEnrollSuccess,
  installmentSuccess,
  installmentFail,
  isPending,
  enrolFail,
} = actions

export default reducer
